import { createReducer } from 'helpers'
import Cookies from 'js-cookie'
import { get, uniqBy } from 'lodash'

export default createReducer({
  me: null,
  featuredPhotos: [],
  albums: [],
  videos: []
}, {
  LOGIN: { onSuccess: (state, { result }) => {
    Cookies.set('sbwshop-token', get(result, 'token'), { expire: 3650 })
    return { ...state, me: get(result, 'me') }
  }},
  VERIFY: { onSuccess: (state, { result }) => ({ me: result }) },
  UPLOAD_COVER: { onSuccess: (state, { result }) => ({ me: { ...state.me, ...result } }) },
  SAVE_VENDOR: { onSuccess: (state, { result }) => ({
    me: { ...state.me,
      nameTh: get(result, 'nameTh'),
      nameEn: get(result, 'nameEn'),
      contactNumber: get(result, 'contactNumber'),
      lineId: get(result, 'lineId'),
      website: get(result, 'website'),
      facebookPage: get(result, 'facebookPage'),
      instagram: get(result, 'instagram')
    }
  }) },
  FIND_FEATURED_PHOTOS: { onSuccess: (state, { result }) => ({ featuredPhotos: result }) },
  ADD_FEATURED_PHOTO: { onSuccess: (state, { result }) => ({ featuredPhotos: state.featuredPhotos.concat([result]) }) },
  REMOVE_FEATURED_PHOTO: { onSuccess: (state, { result }) => ({ featuredPhotos: state.featuredPhotos.filter(photo => photo._id !== result._id) }) },
  COUNT_ALBUMS: { onSuccess: (state, { result }) => ({ albumCount: result }) },
  FIND_ALBUMS: { onSuccess: (state, { result, clear }) => ({ albums: uniqBy((clear ? [] : state.albums).concat(result || []), album => album._id) }) },
  ADD_ALBUM: { onSuccess: (state, { result }) => ({ albumCount: state.albumCount + 1 }) },
  REMOVE_ALBUM: { onSuccess: (state, { result }) => ({ albumCount: state.albumCount - 1 }) },
  COUNT_VIDEOS: { onSuccess: (state, { result }) => ({ videoCount: result }) },
  FIND_VIDEOS: {
    onSuccess: (state, { result, clear, limit }) => ({
      videos: (clear ? [] : state.videos).concat(result || []),
      hasMoreVideos: (result || []).length === limit
    })
  },
  ADD_VIDEO: {
    onSuccess: (state, { result }) => ({
      videoCount: (state.videoCount || 0) + 1,
      videos: [result].concat(state.videos || [])
    })
  },
  REMOVE_VIDEO: {
    onSuccess: (state, { result }) => ({
      videoCount: (state.videoCount || 1) - 1,
      videos: (state.videos || []).filter(video => video._id !== result._id)
    })
  }
}, {
  UPDATE_PROFILE: (state, data) => ({
    ...state, me: { ...state.me, ...data }
  })
})



// WEBPACK FOOTER //
// ./src/redux/vendorReducer.js